import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img_up/shop_pds/kp708/design/img/subimg1.jpg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }

import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sub1',
  setup(__props) {

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "etc",
      subtitle: "etc",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"body_content sub\" data-v-713a7182><h1 class=\"sub_subject\" data-v-713a7182>인사말씀<span data-v-713a7182></span></h1><div class=\"sub01_wrap\" data-v-713a7182><div class=\"box01\" data-v-713a7182><figure data-v-713a7182><img src=\"" + _imports_0 + "\" alt=\"인사말\" data-v-713a7182><span data-v-713a7182>대표이사 강정하</span></figure><div data-v-713a7182><p data-v-713a7182> 새 시대가 미지의 꿈을 품고 상상을 초월하는 모습으로 우리 삶의 한 가운데 자리잡고 있습니다. 미래는 삶 전반을 더 파격적인 모습으로 더 빠르게 바꾸어 가고 있습니다. 변화무쌍한 미래는 보통사람이 창조성을 발휘하여 기회의 세상이 될 것입니다. </p><p data-v-713a7182> 창조성은 꿈을 품고 미래를 준비하는 사람에게 찾아오는 선물입니다. 인간의 창조성은 개인이 유전자의 지시에 따라 발달 과업을 수행하는 가운데, 다양한 경험을 쌓고 재능을 발휘하면서 성장, 발현합니다. 성장기 학생의 창조성은 이따금씩 놀라운, 엉뚱한, 아직은 미성숙한 불확실한 모습을 드러냅니다. 이러한 현상은 창조성의 일면을 보여주는 증거입니다. 성장기 학생의 미미한 창조성은 보호자의 세심한 관심과 보살핌으로 자랍니다. </p><p data-v-713a7182> 창조성은 개인이 세상을 향한 마음을 키우면서 만나는 특별한 경험의 결실입니다. 경험은 마음이 세상과 연결됨으로써 특별해지며, 세상 이해와 자기 이해를 발판으로 자아실현에 이르게 됩니다. 코코랩은 성장기 학생들이 새로운 시대에 새로운 꿈을 품고 새로운 미래를 준비하도록 돕기 위해 설립되었습니다. 코코랩은 성장기 학생들이 미래를 기회로 만드는 확실성을 높일 수 있도록, 이에 최적화된 역량 및 재능 시스템을 구축하는 노력을 지속해오고 있습니다. 코코랩은 분야 최고 전문가들과 함께 하고 있습니다. </p><br data-v-713a7182><p style=\"text-align:center;\" data-v-713a7182>2020년 2월</p><h3 data-v-713a7182><span data-v-713a7182>Ph. D</span> 강 정 하</h3></div></div></div></div>", 1))
    ])
  ]))
}
}

})